import React from 'react';

export const SectionContentSkeleton = () => (
  <div className="animate-pulse space-y-4">
    {/* Title skeleton */}
    <div className="h-6 bg-amber-200 rounded w-3/4"></div>
    
    {/* Paragraph skeletons */}
    <div className="space-y-3 mt-4">
      <div className="h-4 bg-amber-100 rounded w-full"></div>
      <div className="h-4 bg-amber-100 rounded w-full"></div>
      <div className="h-4 bg-amber-100 rounded w-5/6"></div>
    </div>
    
    <div className="space-y-3 mt-6">
      <div className="h-4 bg-amber-100 rounded w-full"></div>
      <div className="h-4 bg-amber-100 rounded w-full"></div>
      <div className="h-4 bg-amber-100 rounded w-4/5"></div>
    </div>
    
    <div className="space-y-3 mt-6">
      <div className="h-4 bg-amber-100 rounded w-full"></div>
      <div className="h-4 bg-amber-100 rounded w-full"></div>
      <div className="h-4 bg-amber-100 rounded w-3/4"></div>
    </div>
  </div>
);

export const QuizSkeleton = () => (
  <div className="animate-pulse space-y-6 p-6 bg-white rounded-lg border-2 border-blue-200">
    <div className="h-5 bg-blue-100 rounded w-1/2"></div>
    
    {/* Question skeletons */}
    {[1, 2, 3, 4, 5].map((i) => (
      <div key={i} className="space-y-3">
        <div className="h-4 bg-gray-200 rounded w-4/5"></div>
        <div className="space-y-2 ml-4">
          <div className="h-10 bg-gray-100 rounded w-full"></div>
          <div className="h-10 bg-gray-100 rounded w-full"></div>
          <div className="h-10 bg-gray-100 rounded w-full"></div>
          <div className="h-10 bg-gray-100 rounded w-full"></div>
        </div>
      </div>
    ))}
  </div>
);

export const SummarySkeleton = () => (
  <div className="animate-pulse bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-6">
    <div className="h-5 bg-blue-200 rounded w-1/3 mb-4"></div>
    <div className="space-y-3">
      <div className="h-4 bg-blue-100 rounded w-full"></div>
      <div className="h-4 bg-blue-100 rounded w-full"></div>
      <div className="h-4 bg-blue-100 rounded w-5/6"></div>
    </div>
  </div>
);

export const LoadingWithProgress = ({ 
  stage = 'loading', 
  message = 'Loading...', 
  progress = 0,
  showProgress = true 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-4 px-4">
      {/* Progress bar */}
      {showProgress && progress > 0 && (
        <div className="w-full max-w-md">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-amber-500 to-amber-600 transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="text-sm text-gray-600 text-center mt-2 font-medium">{Math.round(progress)}% complete</p>
        </div>
      )}
    </div>
  );
};

export const BackgroundGenerationIndicator = ({ sectionNumber, isGenerating }) => {
  if (!isGenerating) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-fade-in">
      <div className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-3 rounded-full shadow-lg flex items-center space-x-3">
        <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
        <span className="font-medium">Section {sectionNumber} preparing in background ⚡</span>
      </div>
    </div>
  );
};
